import * as React from "react";
import type { SVGProps } from "react";

interface SafetyProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const Safety = ({ cancelled = false, ...props }: SafetyProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#FFF"
        stroke="#FFF"
        strokeWidth={1.75}
        d="M4.3 11.3a1.82 1.82 0 0 1 2.25 1.24l1.82 6.27a1.82 1.82 0 0 1-1.24 2.26l-1.83.52a1.82 1.82 0 0 1-2.25-1.25l-1.82-6.26a1.82 1.82 0 0 1 1.25-2.27Zm14.12.16c.4-.23.9-.3 1.38-.16l1.82.51a1.83 1.83 0 0 1 1.25 2.27l-1.82 6.26a1.82 1.82 0 0 1-2.25 1.25l-1.82-.52a1.83 1.83 0 0 1-1.25-2.26l1.82-6.27c.14-.48.46-.86.87-1.08ZM13.9 2.08c.72.92.84 1.36.96 1.97l.55 2.24 1.52 4.98c.41.64 1.14.89 2.14.82l-2.04 7.19c-1.76-.26-2.88-1.13-3.37-2.58-.33-.97-.58-2.75-.72-5.35l-.1-1.46-1.51-1.35c-.47 5.12-.77 7.83-.89 8.16-.5 1.45-1.6 2.32-3.37 2.58l-2.04-7.19c1.04.07 1.79-.2 2.19-.9.37-.64 1.03-3.03 2.02-7.14a4 4 0 0 1 .54-1.56Z"
      />
      <path
        fill="#FFF"
        d="M7.97 11.64c.4-.67 1.1-3.14 2.13-7.4.15-.83.32-1.24.5-1.24q.3 0 .15 1.23l-.47 7.07c-.13 2.49-.35 4.2-.66 5.11a2.79 2.79 0 0 1-1.93 1.84L6.17 12.9a2.6 2.6 0 0 0 1.8-1.26"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M10.6 2c-.97 0-1.23.63-1.48 2.05L8.76 5.5c-.8 3.21-1.37 5.16-1.65 5.63-.24.42-.6.67-1.15.79l-1.05.22 2.1 7.36.97-.3a3.79 3.79 0 0 0 2.58-2.46c.36-1.04.59-2.81.72-5.39l.47-7.05c.18-1.55.1-2.3-1.14-2.3Zm0 1q.3 0 .15 1.23l-.47 7.07-.04.76a19 19 0 0 1-.62 4.35 2.79 2.79 0 0 1-1.93 1.84L6.17 12.9a2.6 2.6 0 0 0 1.8-1.26c.4-.67 1.1-3.14 2.13-7.4.15-.83.32-1.24.5-1.24"
      />
      <path
        fill="#007BBD"
        stroke="#000"
        d="m2.58 12.17 1.83-.51a1.45 1.45 0 0 1 1.78.99l1.82 6.26a1.45 1.45 0 0 1-.99 1.8l-1.82.51a1.45 1.45 0 0 1-1.79-.99l-1.82-6.26a1.45 1.45 0 0 1 .99-1.8Z"
      />
      <path
        fill="#FFF"
        d="M16.13 11.64c-.4-.67-1.1-3.14-2.13-7.4-.15-.83-.32-1.24-.5-1.24q-.3 0-.15 1.23l.47 7.07c.13 2.49.35 4.2.66 5.11.32.92.96 1.53 1.93 1.84l1.52-5.35a2.6 2.6 0 0 1-1.8-1.26"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M13.5 2c.97 0 1.23.63 1.48 2.05l.36 1.45c.8 3.21 1.37 5.16 1.65 5.63.24.42.6.67 1.15.79l1.05.22-2.1 7.36-.97-.3a3.79 3.79 0 0 1-2.58-2.46c-.36-1.04-.59-2.81-.72-5.39l-.47-7.05c-.18-1.55-.1-2.3 1.14-2.3Zm0 1q-.3 0-.15 1.23l.47 7.07.04.76a19 19 0 0 0 .62 4.35c.32.92.96 1.53 1.93 1.84l1.52-5.35a2.6 2.6 0 0 1-1.8-1.26c-.4-.67-1.1-3.14-2.13-7.4-.15-.83-.32-1.24-.5-1.24"
      />
      <path
        fill="#007BBD"
        stroke="#000"
        d="m21.52 12.17-1.83-.51a1.45 1.45 0 0 0-1.78.99l-1.82 6.26a1.45 1.45 0 0 0 .99 1.8l1.82.51a1.45 1.45 0 0 0 1.79-.99l1.82-6.26a1.45 1.45 0 0 0-.99-1.8Z"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default Safety;
